module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// /Users/andrea/Documents/Projects/SW40/landing-portale-privacy/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main